/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import axios from "axios";
import { getCloudPortalV2BaseUrl } from "../../utils/user/user.util";
import { Organization } from "../dto/organization.interfaces";
import {
    InvitedCloudV2TrialUser,
    OnboardCloudV2TrialUserResponse,
    PlatformUser,
} from "../dto/user.interfaces";

const BASE_URL_USER = "/api/user";

export const getUserOrganizations = async (): Promise<Organization[]> => {
    const response = await axios.get(`${BASE_URL_USER}/organizations`);

    return response.data;
};

export const getUser = async (): Promise<PlatformUser> => {
    const response = await axios.get(`${BASE_URL_USER}`);

    return response.data;
};

export const onboardCloudV2TrialUser =
    async (): Promise<OnboardCloudV2TrialUserResponse> => {
        const cloudPortalV2BaseUrl = getCloudPortalV2BaseUrl();
        const response = await axios.post(
            `${cloudPortalV2BaseUrl}/api/v1/ui/trials/onboardTrialUser`
        );

        return response.data;
    };

export const inviteCloudV2TrialUser = async (email: string): Promise<void> => {
    const cloudPortalV2BaseUrl = getCloudPortalV2BaseUrl();
    const response = await axios.post(
        `${cloudPortalV2BaseUrl}/api/v1/ui/trials/invite`,
        { email }
    );

    return response.data;
};

export const getInvitedCloudV2TrialUsers = async (): Promise<
    InvitedCloudV2TrialUser[]
> => {
    const cloudPortalV2BaseUrl = getCloudPortalV2BaseUrl();
    const response = await axios.get(
        `${cloudPortalV2BaseUrl}/api/v1/ui/trials/invitees`
    );

    return response.data.invitees;
};
